module.exports = __webpack_public_path__ + "static/cat-b4360de7160d9e3561591903df687f59.jpg";